import LoadIndicator from "./LoadIndicator";
export default LoadIndicator;
export type { LoadIndicatorProps } from "./LoadIndicator";
